var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"page-forms"}},[_c('v-container',{attrs:{"grid-list-xl":"","fluid":""}},[_c('v-card',[_c('v-card-text',{},[_c('profile-form')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }